import styled from 'styled-components';
import { Card } from 'react-bootstrap';

import { ListaConsumoComponent } from './../components';

export const ListaConsumoPorEmpresasComponent = styled(ListaConsumoComponent).attrs({
    className: `painel-consulta shadow-sm`
})`
    padding: 0.5em 1em;
    margin-bottom: 0.5em;
    
    .tabela{
        
        .registro{
            font-size: 0.9em;
            border-radius: 0.3em;

            &:first-child{
                margin-top: 0;
            }

            td, th{
                border-left: 1px solid #f3f3f3;
                background: #fdfdfd;
                border: 1px solid #f3f3f3;
                padding: 0.25em 0.5em;

                &:first-child{
                    border-top-left-radius: 0.3em;
                    border-bottom-left-radius: 0.3em;
                }
                
                &:last-child{
                    border-top-right-radius: 0.3em;
                    border-bottom-right-radius: 0.3em;
                }
                
                &.indice{
                    color: #525252;
                    font-size: 0.9em;
                    background: #f7fbff;
                    border-color: #e4edf7;
                    border-radius: 0.3em;
                    min-width: 25px;
                }

                .totais{
                    display: flex;
                    align-items: center;
                    gap: 0.5em;
                    justify-content: flex-end;
                    margin-top: 0.3em;
                    
                    .total{
                        padding: 0 0.3em;
                        font-weight: 500;
                        min-width: 50px;
                        display: flex;
                        justify-content: center;
                        box-shadow: 0 0 1px #cbc9c9;

                        b{
                            display: none;
                        }
                    }
                }
            }
        }
    }

    .legenda{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 0.5em;
        font-size: 0.75em;
        margin: 0.7em;
        white-space: nowrap;
    }

    .legenda div, .registro .total{
        display: flex;
        padding: 0 0.4em;
        border-radius: 0.3em;
        border-left: 3px solid;
        background: #fafafa;
        font-weight: 400;
        color: #434343;

        &.geral{
            border-color: #5a5a5a;
        }

        &.nao-encontrado{
            border-color: #d24b4c;
        }

        &.google{
            border-color: #d17401;
        }

        &.retornoReutilizado{
            border-color: #816ecd;
        }

        &.interno{
            border-color: #5da218;
        }

        &.interno-nao-aceito{
            border-color: #f3910d;
        }
    }
`;